import FilterContainer from '@components/048-FilterContainer/FilterContainer';
import gsap from 'gsap';
import { IFilterPanelEmitDetails } from '@frontend/types/modules/content-filter/IContentFilter';

export default class TeaserListB {
	private readonly element: HTMLElement;

	protected filterContainer?: FilterContainer;

	public constructor(element: HTMLElement) {
		this.element = element;
		this.init();
	}

	private init(): void {
		this.initFilter();
		this.setTeaserLinkSpan();

		window.addEventListener('resize', (): void => {
			this.setTeaserLinkSpan();
		});
	}

	protected initFilter(): void {
		const filterContainer: HTMLElement | null = this.element.querySelector('.m-teaser-list-b__filter-container');
		const filterPanel: HTMLElement | null = this.element.querySelector('.m-teaser-list-b__filter-panel');

		if (filterContainer && filterPanel) {
			this.filterContainer = new FilterContainer(filterContainer, {
				panel: filterPanel,
				onAfterRenderResult: (instance): void => {
					if (instance.dataFromPanel) {
						this.updateSingleOccasionModifier(instance.dataFromPanel);
					}

					gsap.from('.m-teaser-list-b__teaser', {
						opacity: 0,
						duration: 0.3,
						clearProps: true
					});

					setTimeout((): void => {
						this.setTeaserLinkSpan();
					}, 50);
				}
			});
		}
	}

	protected updateSingleOccasionModifier(panelData: IFilterPanelEmitDetails): void {
		if (panelData.activeFilters.occasion && panelData.activeFilters.occasion.length === 1) {
			this.element.classList.add('has-single-occasion');
		} else {
			this.element.classList.remove('has-single-occasion');
		}
	}

	/**
	 * Set the span of the teaser item to fill the remaining space in the grid.
	 * Would have been to verbose with CSS only.
	 */
	protected setTeaserLinkSpan(): void {
		const teaserLink = this.element.querySelector('.m-teaser-list-b__teaser-link-wrapper');
		const products: HTMLAnchorElement[] = Array.from(document.querySelectorAll('.m-teaser-list-b__teaser'));
		const lastProduct = products[products.length - 1];
		const wrapperWidth = this.element.getBoundingClientRect().width;

		if (!teaserLink || !lastProduct) return;

		const lastProductLeft = Math.floor(lastProduct.offsetLeft);
		const lastProductRight = Math.floor(lastProduct.offsetLeft + lastProduct.offsetWidth);
		const untilL = window.matchMedia('screen and (max-width: 980px)');

		const maxCols = untilL.matches ? 2 : 4;

		let teaserLinkSpan = this.isRtl()
			? Math.round(maxCols - (wrapperWidth - lastProductLeft) / (wrapperWidth / maxCols))
			: Math.round((wrapperWidth - lastProductRight) / (wrapperWidth / maxCols));

		teaserLinkSpan = teaserLinkSpan || maxCols;

		teaserLink.setAttribute('data-grid-span', teaserLinkSpan.toString());
	}

	protected isRtl(): boolean {
		return document.dir === 'rtl';
	}
}
